import React from "react";
import Content from "components/Content";
import { useSelector } from "react-redux";
import { EuiBasicTable } from "@elastic/eui";
import { useAddQueryNavigation } from "helpers/hooks/url";

const CollectionList = () => {
  const collections = useSelector(state => state.collections.items);
  const addQuery = useAddQueryNavigation();

  const actions = [
    {
      name: "Löschen",
      description: "Diese Kollektion löschen",
      icon: "trash",
      color: "danger",
      type: "icon",
      onClick: e => {
        addQuery("deleteCollection", e.id);
      }
    },
    {
      name: "Edit",
      isPrimary: true,
      description: "Diese Kollektion bearbeiten",
      icon: "pencil",
      type: "icon",

      onClick: e => {
        addQuery("editCollection", e.id);
      }
    }
  ];

  const columns = [
    { field: "id", name: "#" },
    { field: "name", name: "Name" },
    { field: "description", name: "Beschreibung" },
    { field: "color", name: "color" },

    { field: "updated_at", name: "Letztes Update", dataType: "date" },
    { field: "created_at", name: "Erstellt am", dataType: "date" },

    { name: "Aktionen", actions }
  ];

  return (
    <Content title="Übersicht">
      <EuiBasicTable items={Object.values(collections)} columns={columns} />
    </Content>
  );
};
export default CollectionList;
